'use client'

import TabPanel from "components/TabPanel";
import TabView from "components/TabView";
import { useEffect, useMemo, useState } from "react";
import { Alert, Button, Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import Dados from "./Dados";
import { validate } from "components/validateGeneralForm";
import Empresas from "./Empresas";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { useNavigate, useParams } from "react-router-dom";
import CustomDropzone from "components/CustomDropzone";
import consorcioService from "services/ConsorcioService";
import { toast } from "react-toastify";
import { erroInesperado } from "services/Utils";
import arquivoService from "services/ArquivoService";
import { alert } from "components/Alert";
import ResponsaveisConsorcio from "components/ResponsaveisConsorcio";

export default function FormConsorcio() {
  const [data, setData] = useState({})
  const [edit, setEdit] = useState(false)
  const [arquivo, setArquivo] = useState(null)
  const [arquivoLogo, setArquivoLogo] = useState(null)
  const params = useParams()
  const navigate = useNavigate()
  const [version, setVersion] = useState(0)

  const id = parseInt(params.id)
  const novo = (0 === id)

  useEffect(() => {
    if (!!id) {
      consorcioService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      setData({})
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  const formConfig = useMemo(() => {
    return [
      [
        { name: "nome", label: 'Nome', type: "text", required: true, colspan: 8 },
        {
          name: "instrumento",
          type: "view",
          required: true,
          colspan: 6,
          component: () => {
            if (arquivo || data.instrumento) {
              const nomeArquivo = arquivo ? arquivo.name : data.instrumento.nomeArquivo
              const funcaoExcluir = arquivo ? () => handleChangeInstrumento(null) : () => handleChange('instrumento', null)
              return (
                <Row>
                  <Col xs={8}>
                    <FormGroup>
                      <Label>Instrumento</Label>
                      <Input type="text" value={nomeArquivo} disabled={true} />
                    </FormGroup>
                  </Col>
                  <Col xs={4} className="d-flex align-items-end">
                    {edit && (
                      <FormGroup>
                        <Button color="danger" outline onClick={funcaoExcluir}>
                          Excluir
                        </Button>
                      </FormGroup>
                    )}
                  </Col>
                </Row>
              )
            }
            return (
              <>
                <div>Instrumento</div>
                <CustomDropzone
                  onChange={value => handleChangeInstrumento(value)}
                  onRemove={() => handleChangeInstrumento(null)}
                  edit={edit}
                />
              </>
            )
          }
        },
        {
          name: "logo",
          type: "view",
          required: false,
          colspan: 6,
          component: () => {
            if (arquivoLogo || data.logo) {
              const nomeArquivo = arquivoLogo ? arquivoLogo.name : data.logo.nomeArquivo
              const funcaoExcluir = arquivoLogo ? () => handleChangeLogo(null) : () => handleChange('logo', null)
              return (
                <Row>
                  <Col xs={8}>
                    <FormGroup>
                      <Label>Logo</Label>
                      <Input type="text" value={nomeArquivo} disabled={true} />
                    </FormGroup>
                  </Col>
                  <Col xs={4} className="d-flex align-items-end">
                    {edit && (
                      <FormGroup>
                        <Button color="danger" outline onClick={funcaoExcluir}>
                          Excluir
                        </Button>
                      </FormGroup>
                    )}
                  </Col>
                </Row>
              )
            }
            return (
              <>
                <div>Logo</div>
                <CustomDropzone
                  onChange={value => handleChangeLogo(value)}
                  onRemove={() => handleChangeLogo(null)}
                  edit={edit}
                />
              </>
            )
          }
        },
      ],
    ]
  }, [data.instrumento, data.logo, arquivo, arquivoLogo, edit])

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const handleChangeInstrumento = (value) => {
    if (!value) {
      setData({ ...data, instrumento: null })
    }
    setArquivo(value)
  }

  const handleChangeLogo = (value) => {
    if (!value) {
      setData({ ...data, logo: null })
    }
    setArquivoLogo(value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      // erros foram encontrados
      return
    }

    try {
      if (arquivo) {
        const res = await arquivoService.upload(arquivo)
        if (res.success) {
          data.instrumento = { id: res.data }
        } else {
          toast('Erro ao enviar arquivo')
          return
        }
      }

      if (arquivoLogo) {
        const res = await arquivoService.upload(arquivoLogo)
        if (res.success) {
          data.logo = { id: res.data }
        } else {
          toast('Erro ao enviar arquivo')
          return
        }
      }

      if (novo) {
        await consorcioService.create(data)
      } else {
        await consorcioService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate('/admin/consorcios')
    } catch (ex) {
      erroInesperado()
    }

  }

  const handleTabChange = (id, cancel) => {
    if (id == 2 && novo) {
      alert({
        header: 'Atenção!!',
        text: 'Antes de cadastrar as empresas você precisa salvar o consório'
      })
      cancel()
    }
  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Consórcios" edit={edit} onChangeEdit={setEdit} showButton={!novo} />

      <TabView onTabChange={handleTabChange}>
        <TabPanel label="Dados">
          <form onSubmit={handleSubmit}>
            <Alert color="danger" className="mb-4">
              <p>
                <strong>Atenção:</strong> Cadastre como consórcio apenas quando houver mais de uma empresa executando e necessidade de distribuição de Ordens de Serviço entre elas.
              </p>
              <p style={{ marginBottom: 0 }}>
                Caso apenas uma empresa execute os serviços (mesmo que juridicamente seja um consórcio), cadastre como empresa.
              </p>
            </Alert>

            <Dados data={data} onChange={handleChange} formConfig={formConfig} edit={edit} />
            {edit && (
              <div className="mt-2">
                <Button type="submit" color="primary">Salvar</Button>
              </div>
            )}
            <hr />
            {!!id && (
              <div className="row">
                <ResponsaveisConsorcio idConsorcio={id} key={version} />
              </div>
            )}
          </form>
        </TabPanel>
        <TabPanel label="Empresas">
          <Empresas idConsorcio={id} edit={edit} onChange={() => setVersion(v => v + 1)} />
        </TabPanel>
      </TabView>
    </Container>
  )
}